var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDottimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.58337,
    y: 4.58337,
    width: 9.16667,
    height: 9.16667,
    rx: 1.83333,
    fill: "#333F61"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.58337,
    y: 17.4166,
    width: 9.16667,
    height: 9.16667,
    rx: 1.83333,
    fill: "#333F61"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.58337,
    y: 30.25,
    width: 9.16667,
    height: 9.16667,
    rx: 1.83333,
    fill: "#333F61"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 17.4166,
    y: 4.58337,
    width: 9.16667,
    height: 9.16667,
    rx: 1.83333,
    fill: "#333F61"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 17.4166,
    y: 17.4166,
    width: 9.16667,
    height: 9.16667,
    rx: 1.83333,
    fill: "#333F61"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 17.4166,
    y: 30.25,
    width: 9.16667,
    height: 9.16667,
    rx: 1.83333,
    fill: "#333F61"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 30.25,
    y: 4.58337,
    width: 9.16667,
    height: 9.16667,
    rx: 1.83333,
    fill: "#333F61"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 30.25,
    y: 17.4166,
    width: 9.16667,
    height: 9.16667,
    rx: 1.83333,
    fill: "#333F61"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 30.25,
    y: 30.25,
    width: 9.16667,
    height: 9.16667,
    rx: 1.83333,
    fill: "#333F61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDottimg);
export default __webpack_public_path__ + "static/media/dottimg.0e30900f6559a1f19bad8ac8c01b05c1.svg";
export { ForwardRef as ReactComponent };